export const BRANDS_TABLE_NAME = "brands";
export const PROMPTS_TABLE_NAME = "prompts";
export const MODELS_TABLE_NAME = "models";
export const USER_MODELS_TABLE_NAME = "user_models";
export const RESPONSES_TABLE_NAME = "responses";
export const SCORES_TABLE_NAME = "scores";
export const USERS_META_TABLE_NAME = "users_meta";

export const BRANDS_SCORE_DAILY_TABLE_NAME = "brands_score_daily";
export const BRANDS_PROMPTS_SCORE_DAILY_TABLE_NAME = "brands_prompts_score_daily";
export const BRANDS_MODELS_SCORE_DAILY_TABLE_NAME = "brands_models_score_daily";

export const OVERVIEW_DOMAINS_AGG_VIEW_NAME = "overview_domains_agg";
export const OVERVIEW_SOURCE_DETAIL_LINKS_VIEW_NAME =
  "overview_source_detail_links";
export const SOURCES_TABLE_NAME = "sources";
